<div
  class="checkout-form-container"
  [class.disabled]="disabled"
  [class.linked-account-top]="shouldRenderLinkedAccountOnTop">
  <ng-container *ngIf="shouldRenderLinkedAccountOnTop">
    <ng-container *ngTemplateOutlet="checkoutLinkedAccount"></ng-container>
  </ng-container>

  <p
    class="enrollment-text"
    *ngIf="shouldRenderEnrollmentText"
    [ngClass]="{
      'ml-4': shouldRenderLinkedAccountOnTop
    }">
    <span class="enrollment-question">{{
      'transfer_v2.checkout.not_a_member' | translate
    }}</span>
    <rd-shared-link
      class="enrollment-url"
      [text]="'transfer_v2.checkout.join_now' | translate"
      [path]="loyaltyProgram.pointsTransferCapability.enrollmentUrl.toString()"
      [isTargetBlank]="true">
    </rd-shared-link>
  </p>

  <div
    class="checkout-form my-5 rounded-md"
    [ngSwitch]="getComponentRenderState()"
    [class.collapsible-form]="collapsibleTransferAmountForm"
    [ngClass]="{
      'mb-2.5': shouldRenderLinkedAccountOnTop
    }">
    <ng-container *ngSwitchCase="'content'">
      <button
        *ngIf="collapsibleTransferAmountForm"
        class="header-button p-4"
        [ngClass]="{
          'rounded-md': !expanded,
          'rounded-md-t': expanded,
          expanded: expanded,
          disabled: disabled
        }"
        tabindex="0"
        (click)="toggleExpansion()">
        <span class="header-text-description">{{
          'transfer_v2.checkout.header_text' | translate
        }}</span>
        <span class="downward-arrow-container p-1">
          <rd-shared-icon
            class="expander-icon"
            [class.expanded]="expanded"
            [iconSymbol]="'icon-arrow-down'"
            [iconTheme]="iconTheme()"></rd-shared-icon>
        </span>
      </button>
      <div
        #expandableContent
        class="expanded-content rounded-md-b m-0"
        [ngClass]="{
          'py-0': expanded,
          'py-5': collapsibleTransferAmountForm && expanded,
          expanded: expanded
        }">
        <h2
          class="form-main-text-description rounded-md-t m-0 px-4 py-5"
          *ngIf="!collapsibleTransferAmountForm">
          {{ 'transfer_v2.checkout.header_text' | translate }}
        </h2>
        <form [formGroup]="checkoutForm" (ngSubmit)="onSubmit()">
          <rd-tcv2-checkout-transfer-amount-form
            formControlName="transferAmountForm"
            [currencyConversionLoading]="currencyConversionLoading$.value"
            [formData]="formData"
            [isSubmitted]="isSubmitted$"
            [collapsibleTransferAmountForm]="collapsibleTransferAmountForm"
            [loyaltyProgram]="loyaltyProgram"
            (updateDebounceLoading)="setDebounceLoading($event)"
            (updateCurrencyConversionLoading)="
              setCurrencyConversionLoading($event)
            ">
          </rd-tcv2-checkout-transfer-amount-form>

          <ng-container *ngIf="shouldRenderLinkedAccountOnBottom">
            <ng-container
              *ngTemplateOutlet="checkoutLinkedAccount"></ng-container>
          </ng-container>

          <rd-shared-button
            *ngIf="
              shouldRenderCheckoutButton && shouldRenderSubmitButtonInsideForm
            "
            class="submit-button rounded-md"
            [buttonType]="'submit'"
            [buttonClass]="'submit-button'"
            [buttonContent]="checkoutSubmitButtonContent"
            [buttonTheme]="'primary'"
            [isDisabled]="!!(loadingState$ | async)">
          </rd-shared-button>
        </form>

        <ng-container *ngIf="isAutoRedemptionEnabled">
          <div class="membership-button mt-5 p-4 lg:p-0">
            <rd-shared-button
              class="rounded-md"
              [buttonClass]="'text'"
              [buttonContent]="buttonContent"
              [buttonTheme]="'primary'"
              [isDisabled]="!!(loadingState$ | async)"
              (clickFn)="onSubmit()">
              <ng-template #buttonContent>
                <span class="submit-button-text">{{
                  'transfer_v2.checkout.submit_button_text' | translate
                }}</span>
              </ng-template>
            </rd-shared-button>
          </div>
          <ng-container
            *ngIf="isAutoRedemptionEnabled && (autoRedemptionEnabled$ | async)">
            <div class="mt-8 flex w-full flex-col items-start px-4 lg:px-0">
              <h2
                class="setup-auto-redemp-title typo-heading-3-mobile lg:typo-heading-3-desktop my-0">
                {{
                  'transfer_v2.checkout.set_up_auto_redemption.title'
                    | translate
                }}
              </h2>

              <div class="typo-text-mobile lg:typo-text-desktop mt-2">
                {{
                  'transfer_v2.checkout.set_up_auto_redemption.text'
                    | translate: { loyaltyProgram: loyaltyProgram.name }
                }}
              </div>

              <div class="setup-auto-redemp-button-container mt-5">
                <rd-shared-button
                  class="setup-auto-redemp-button"
                  [buttonClass]="'text'"
                  [buttonContent]="buttonContent"
                  [buttonTheme]="'outline-primary'"
                  (clickFn)="redirectToTcAutoRedeemPage()">
                  <ng-template #buttonContent>
                    <span
                      class="setup-auto-redemp-button-text flex items-center justify-center"
                      >{{
                        'transfer_v2.checkout.set_up_auto_redemption.button.text'
                          | translate
                      }}</span
                    >
                  </ng-template>
                </rd-shared-button>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'loading'">
      <div class="loading-checkout-form-container rounded-md px-4 lg:px-0">
        <div class="form-main-text-description loading-height p-0"></div>
        <div class="checkout-form">
          <div
            class="source-amount loading-text-100 loading-text-desktop-40 p-0"></div>
          <div
            class="destination-amount loading-text-100 loading-text-desktop-40 mt-5 p-0 lg:ml-5 lg:mt-0"></div>
        </div>
        <div class="submit-button button-height rounded-md"></div>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="shouldRenderLinkedAccountOnOutside">
    <ng-container *ngTemplateOutlet="checkoutLinkedAccount"></ng-container>
  </ng-container>
  <rd-shared-button
    *ngIf="shouldRenderCheckoutButton && !shouldRenderSubmitButtonInsideForm"
    class="submit-button rounded-md"
    [buttonType]="'submit'"
    [buttonClass]="'submit-button'"
    [buttonContent]="checkoutSubmitButtonContent"
    [buttonTheme]="'primary'"
    [isDisabled]="!!(loadingState$ | async)"
    (clickFn)="onSubmit()">
  </rd-shared-button>
</div>

<ng-template #checkoutSubmitButtonContent>
  <span class="loading-text" *ngIf="loadingState$ | async; else loaded">
    {{ 'transfer_v2.checkout.submit_button_text_loading' | translate }}
  </span>
  <ng-template #loaded>
    <span class="submit-button-text">{{
      'transfer_v2.checkout.submit_button_text' | translate
    }}</span>
  </ng-template>
</ng-template>

<ng-template #checkoutLinkedAccount>
  <rd-tcv2-checkout-linked-account
    *ngIf="!isAutoRedemptionEnabled"
    class="mt-5"
    [isLoggedIn]="isLoggedIn"
    [loading]="loyaltyProgramOrMembershipsLoading"
    [linkedAccount]="linkedAccount"
    [loyaltyProgram]="loyaltyProgram">
  </rd-tcv2-checkout-linked-account>
</ng-template>
